'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _reactReduxToastr = require('react-redux-toastr');

var _modules = require('./modules');

var modules = _interopRequireWildcard(_modules);

var _reduxForm = require('redux-form');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)((0, _extends3.default)({
  routing: _reactRouterRedux.routerReducer,
  toastr: _reactReduxToastr.reducer,
  form: _reduxForm.reducer,
  reduxAsyncConnect: _reduxConnect.reducer
}, modules));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducer.js
// module id = 2238
// module chunks = 1